/**
 * Categories accepted by `POST /api/document-pages/:id/extract-as`.
 * The `ApiPathDocumentPagesIdExtractAs` body union derives from this list.
 * Keep in lockstep with server `EXTRACT_AS_CATEGORIES` (`server/src/constants.ts`);
 * `extract-as.test.ts` pins the two by mutual assignability.
 */
export const EXTRACT_AS_CATEGORIES = [
    'Engine Installation/Removal History',
    // Operator end-of-lease Engine Operational Report — the same agentic engine-events
    // extractor, unchanged (DR-5162).
    'Engine Operational Report',
    'Part Movement Traceability Card',
    'LLP Status',
    'AD Status',
    'LDND',
    'SB Status',
    // Operator SB/Modification statements — same agentic SB extractor (DR-3191).
    'SB Statement',
    'Bill of Sale',
    // Dual AD+SB extract categories (DR-2100).
    'Recorded Modification Sheet',
    'AD-SB-LLP Status Sheet',
    'LLP - EDS',
    'LLP - VSL',
    // Three-way LLP+AD+SB extract (DR-3447). Not a dual-extract member.
    'P/N Detail Print',
    // ARC routes over the six release-cert categories (DR-1898).
    'Engine Parts Release Certificate',
    'Fan Blade Release Certificates',
    'Engine Release Certificate',
    'Accessory and QEC Release Certificates',
    'LLP Release Certificate',
    'Module Release Certificate',
    // Accessory/QEC list extractor (DR-2024).
    'Accessory and QEC List',
    // Two-way LLP+QEC extract for a full/mixed AMOS Component Equipment List print (DR-3952).
    'Engine Configuration List',
    // Single-call utilisation extractor (DR-524).
    'Utilisation Records',
    // Single-call engine manufacture certificate extractor (DR-2421).
    'Engine Manufacture Certificate',
    // Birth / manufacture logbook pages — the same single-call extractor with a
    // logbook-specific hint (DR-4129).
    'Manufacture Logbook',
    // Single-call PMA/DER status extractor (DR-3128).
    'PMA/DER Status',
    // Operator in-house / non-OEM modification letters — the same single-call PMA/DER extractor (DR-6005).
    'In House Modifications Statement',
    // Single-call non-exceedance statement reader (DR-6373).
    'No Exceedance Statement',
    // Single-call engine oil type reader (DR-6375).
    'Engine Oil Type Used Statement',
    // Single-call engine workscope extractor (DR-3126).
    'Engine Workscope',
    // Single-call borescope / inspection report extractor (DR-4817).
    'Borescope Report',
    // Single-call repair / workshop report extractor (DR-4817).
    'Repair Report',
    // Teardown / WORK ORDER FORM 100 pages — the same single-call repair extractor (DR-5043).
    'Accessory/Parts Teardown Report',
    // Single-call NIS statement extractor (DR-3125).
    'NIS Statement',
    // Single-call thrust-conversion extractor (DR-3127).
    'Thrust Rating Change Records',
    // Single-call engine movement extractor (DR-3249).
    'Engine Install Removal Job Cards',
    // Single-call Current TSN and CSN Statement extractor (DR-3769).
    'Current TSN and CSN Statement',
    // Single-call build-record extractor for aircraft delivery records (DR-5094).
    'Aircraft Readiness Log / Aircraft Inspection Report',
    // Single-call build-record extractor for the Rolls-Royce DIS serialised parts list (DR-5161).
    'LLP - DIS',
    // Single-call flight-log extractor, one hint per category (DR-5163).
    'Tech Log Sheets',
    'Ferry Flight Statement',
    // Single-call part-tag extractor (DR-5137).
    'Removal Tags',
    // Single-call AD-text service-bulletin reference extractor (DR-5796).
    'Airworthiness Directives Reference',
    // Single-call concession extractor, one hint per category (DR-5166).
    'OEM Concessions Statement',
    'Major Repair or Alteration Form',
    // Same single-call concession extractor and hint as the OEM statement (DR-5263).
    'DICA Records',
    // Single-call blade / nozzle configuration-sheet extractor (DR-5467, DR-5508, DR-5561).
    'HPT Blade Status',
    'HPT Nozzles',
    'LPT Nozzles',
    'Fan Blades Distribution List',
    'Fan Blade Installation Records',
];
//# sourceMappingURL=extract-as-categories.js.map